// combatpro/panels/monsters/studio/MonsterStudioVersions.js
//
// Combat PRO - MonsterStudioVersions (Stage 58: Persistence & Cloud CRUD).
//
// The version-history modal (#vi-st-versions-modal), a faithful port of the legacy
// viStudioRenderVersions (battletracker.html 11482-11492): an active-version header
// (current name + last-saved) followed by one row per stored snapshot, newest first,
// each offering Restore / Duplicate / Delete. The snapshot order and the displayed
// "Version N" numbering match the legacy exactly (rows reversed for display; the
// action index is the true array index). It renders only - all behaviour is owned by
// the persistence runtime and routed through onRestore / onDuplicate / onDelete /
// onClose. No DOM access, no manual HTML. No optional chaining. No em dash.

import React from 'react';

function formatTime(ts) {
  if (!ts) { return ''; }
  try {
    var d = new Date(ts);
    return d.toLocaleString();
  } catch (e) {
    return '';
  }
}

function MonsterStudioVersions(props) {
  if (!props.open) { return null; }
  var model = props.model || {};
  var versions = Array.isArray(model.versions) ? model.versions : [];
  var activeName = model.customName || model.name || 'Current';
  var lastSaved = model.lastSaved ? formatTime(model.lastSaved) : 'not saved';

  return (
    <div className="vi-st-versions-modal" id="vi-st-versions-modal" style={{ display: 'flex' }}>
      <div className="vi-st-versions-card">
        <div className="vi-st-versions-head">
          <span>Version History</span>
          <button type="button" className="vi-st-versions-close" onClick={props.onClose}>{'\u2715'}</button>
        </div>
        <div className="vi-st-versions-body" id="vi-st-versions-body">
          <div className="vi-st-ver-active">
            Active version {'\u2014'} <b>{activeName}</b> {'\u2022'} last saved {lastSaved}
          </div>
          {versions.length === 0 ? (
            <div className="vi-st-ver-empty">
              No earlier versions yet. Each save keeps the previous version (up to 10).
            </div>
          ) : (
            versions.slice().reverse().map(function(v, ri) {
              var idx = versions.length - 1 - ri;
              return (
                <div className="vi-st-ver-row" key={idx}>
                  <div className="vi-st-ver-info">
                    <b>Version {idx + 1}</b>
                    <span>{(v.name || '')} {'\u2022'} {v.ts ? formatTime(v.ts) : ''}</span>
                  </div>
                  <div className="vi-st-ver-acts">
                    <button type="button" onClick={function() { props.onRestore(idx); }}>Restore</button>
                    <button type="button" onClick={function() { props.onDuplicate(idx); }}>Duplicate</button>
                    <button type="button" className="vi-st-danger" onClick={function() { props.onDelete(idx); }}>Delete</button>
                  </div>
                </div>
              );
            })
          )}
        </div>
      </div>
    </div>
  );
}

export default MonsterStudioVersions;
